import React from 'react';
import { motion } from 'framer-motion';
export function NonHormonal() {
  return <section className="bg-[#0A0A0A] py-20 md:py-28" data-id="element-179">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto px-6" data-id="element-180">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F0] tracking-tight mb-10 leading-tight" data-id="element-181">
          There's a Path That Doesn't Ask You to Trade Your Hormones for Your
          Hair.
        </h2>

        <div className="space-y-6 text-lg text-[#9CA3AF] leading-relaxed" data-id="element-182">
          <p data-id="element-183">
            The reason most men are still searching — still Googling at 11pm —
            is not because they don't know their options. It's because the
            option most people recommend scares them.
          </p>
          <p data-id="element-184">
            The sexual side effects of finasteride are documented and real for a
            meaningful percentage of users. Men describe brain fog, loss of
            libido, a feeling of being disconnected from themselves.
          </p>
        </div>

        {/* Callout Quote */}
        <div className="my-10 bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg p-8" data-id="element-185">
          <p className="text-xl italic text-[#F5F5F0] leading-relaxed" data-id="element-186">
            "Brain fog, not feeling myself, low libido. I thought this and
            stopped."
          </p>
        </div>

        <div className="space-y-6 text-lg text-[#9CA3AF] leading-relaxed" data-id="element-187">
          <p data-id="element-188">
            That's a rational response to a real risk. And the industry's answer
            — "the benefits outweigh the risks for most men" — means nothing to
            the man who isn't most men.
          </p>

          <h3 className="text-2xl md:text-3xl font-bold text-[#F5F5F0] tracking-tight pt-6" data-id="element-189">
            A Completely Separate Pathway
          </h3>
          <p data-id="element-190">
            Photobiomodulation operates independently of your hormonal system.
            No DHT interaction. No androgen suppression. No risk of sexual
            dysfunction.
          </p>
          <p data-id="element-191">
            Light stimulates mitochondrial activity in follicle cells. Your
            hormones are not involved.
          </p>
          <p data-id="element-192">
            <strong className="text-[#F5F5F0]" data-id="element-193">
              For men who want results without a masculinity tradeoff, this is
              not plan B. It is a different mechanism entirely.
            </strong>
          </p>
          <p className="text-xl font-bold text-[#C8A04A] pt-4" data-id="element-194">
            No pills. No chemicals. No compromise.
          </p>
        </div>
      </motion.div>
    </section>;
}